export default "__VITE_ASSET__UovuKbMv__"